<template>
    <v-flex>
      <v-toolbar flat class="mb-4 text-xs-center">
        <v-toolbar-title class="headline text-xs-center">Singer Savvy Terms of Service/Consent</v-toolbar-title>
      </v-toolbar>
      <v-card flat tile class="mb-4">
          <v-container  fluid grid-list-lg >
            <v-layout >
              <v-flex justify-center text-xs-left>
                <v-card-text>
                  <h2 >Terms of Service/Consent </h2>
                  <p> (Same info provided when you created your account and clicked "Agree") </p>
                  <p> By registering as a user of the Singer Savvy App, you are also giving
                    consent to allow the de-identified data you enter to potentially be
                    included in the Research Study: Singer Savvy App: Voice Tracking and
                    Budgeting System for Singers (IRB Study Number: 00207688) </p>
                  <p> The Principal Investigator for this study is Theresa Brancaccio. </p>
                  <h2> This research is supported by The Department of Voice and Opera, Bienen
                    School of Music and is funded by the Provosts Digital Learning
                    Fellowship at Northwestern University. </h2>
                  <p> The following is a short summary of this study to help you decide whether
                    to be a part of this study. </p>
                  <p> This study will investigate how singers who track the circumstances and
                    frequency under which they use their voices can make correlations between
                    their behaviors and levels of vocal fatigue. I hypothesize that if singers
                    do a daily self-assessment of their vocal condition and then stay within a
                    recommended "vocal budget" they will see trends toward improved vocal
                    condition/function. The app will offer guidance on testing vocal function,
                    spacing out intense sessions of voice use, speaking well, vocal hygiene,
                    tracking water intake, and "vocal naps". </p>
                  <h3> A database of 100 users who use the app for at least 10 days within a
                    30-day period will be studied to how well this kind of habit tracking
                    impacts levels of vocal fatigue and also whether correlations can be
                    made between age groups /voice types/musical styles/gender WITH
                    patterns of vocal fatigue </h3>
                  <h2>Why am I being asked to take part in this research study?</h2>
                  <p> I am asking you to take part in this research study because you are a
                    vocalist, at least 18 years of age. </p>
                  <h2>What should I know about a research study?</h2>
                  <p> If you register to use the Singer Savvy app, that implies your consent to
                    be part of this study. You will be included in this research study if you
                    use Singer Savvy for at least 10 days within a 30-day period. </p>
                  <p> As part of your registration, you will be asked to provide information
                    about your age range, voice type, gender and musical genres your perform.
                    When using the app, you will be asked to assess your voice function, choose
                    how your voice feels and then enter each voice task throughout the day.
                    Additionally, you may enter water intake and vocal naps. You should look at
                    the Stats page to note how well you stayed within your Voice Budget for the
                    day and how that relates to your Vocal Condition the following morning. </p>
                  <p><strong>Primary risk of participation</strong> : None. </p>
                  <p> Main benefit of participation: Singers can become more mindful of voice use
                    and vocal loads, thus encouraging healthier vocal habits. This may lead to
                    more consistency in vocal functionality and may help to avoid vocal injury. </p>
                  <h2> What happens if I do not want to be in this research or if I say "Yes",
                    but I change my mind later? </h2>
                  <p> You can decide not to participate in this research or you can start and
                    then decide to leave the research and it will not be held against you. To
                    do so, discontinue using the application before 10 days and your data will
                    not be used in the study. If you have used the app for more than 10 days
                    and decide to withdraw from the study, you can submit your request by using
                    the Feedback Button in the Info Section (icon in upper right-hand corner).
                    Your account info will be deleted within one week of the request. </p>
                  <h2> What happens to the information collected for the research? </h2>
                  <p> This survey is being hosted by Amazon Web Services cloud provider in the
                    official Northwestern University Account managed by ITSS Media and Design
                    and involves a secure connection. Terms of service, addressing
                    confidentiality, may be viewed at <a href="https://aws.amazon.com/agreement/"> https://aws.amazon.com/agreement/ </a> </p>
                  <p> Databases are password protected by Amazon Web Services (AWS) and AWS
                    Cognito Service. Participants will be assigned a random number in all the
                    activities and events stored in the application. Participants are limited
                    to only accessing and submitting data tied to their randomly assigned ID
                    number. The results of the research study may be published, but data will
                    be used only in a collective, generalized manner and participants will be
                    anonymous. </p>
                  <h2>What else do I need to know?</h2>
                  <p> You can check the website SingerSavvyApp.com in the future for updates
                    related to the study and the application. Updates may also be included on
                    the Facebook page named Singer Savvy App </p>
                  <h2>Who can I talk to?</h2>
                  <p> If you have questions, concerns, or complaints talk to the Principal
                    Investigator: Theresa Brancaccio </p>
                  <p> <a href="mailto:tbrancaccio@northwestern.edu"> tbrancaccio@northwestern.edu </a> 847.491.4518 </p>
                  <p> This research has been reviewed and approved by an Institutional Review
                    Board ("IRB"). You may talk to them at (312) 503-9338 or <a href="mailto:irb@northwestern.edu">irb@northwestern.edu</a> if: </p>
                  <ul type="disc">
                    <li> Your questions, concerns, or complaints are not being answered by the
                      research team. </li>
                  </ul>
                  <ul type="disc">
                    <li> You cannot reach the research team. </li>
                    <li> You want to talk to someone besides the research team. </li>
                    <li> You have questions about your rights as a research participant. </li>
                    <li> You want to get information or provide input about this research. </li>
                  </ul>
                  <h2>Consent</h2>
                  <p> If you want a copy of this consent for your records, you can print it from
                    the screen. </p>
                  <p> If you wish to participate, please click the "I Agree" button and you will
                    be registered to use Singer Savvy. </p>
                  <p> If you decide to withdraw from the study, you can submit your request by
                    using the Feedback Button in the Info Section (icon in upper right-hand
                    corner). Your account info will be deleted within one week of the request. </p>
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card> 
    </v-flex>
</template>
<style scoped>
h2:first-child{ margin-top: 0;}
h2{ 
  line-height: 2rem;
  margin: 2.5rem 0 1.25rem 0;
}
ul{
  padding-left: 2rem;
}
</style>

<script>


export default {
  data () {
    return {
      msg: 'Good Morning, '+localStorage.username+'!'
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/TermsOfService.vue